import React, { useState } from "react";
import styles from "./hero.module.scss";

export const MissionHero = ({ video }) => {
  return (
    <section className={styles.section_aboutus_hero}>
      <div className="container">
        <div className={styles.wrapper}>
          <h1>
            <span className="mark">Vision Mission</span>
          </h1>
          <p>
            We strive to optimise international student recruitment for success,
            helping universities and students minimise uncertainty and maximise
            meaningful connections. Our mission is to be the complete, one-stop
            solution bridging the distance between students from emerging
            markets looking to study abroad and universities seeking best-fit
            candidates from these diverse markets.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionHero;
